/*!
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { getClient, getDefaultPropfind, getRootPath, resultToNode } from '@nextcloud/files/dav';
export const client = getClient();
/**
 * Fetches a node from the given path
 *
 * @param path - The path to fetch the node from
 */
export async function fetchNode(path) {
    const propfindPayload = getDefaultPropfind();
    const result = await client.stat(`${getRootPath()}${path}`, {
        details: true,
        data: propfindPayload,
    });
    return resultToNode(result.data);
}
